/**
 * Enum kỳ báo cáo
 * Created by: nvcuong1 09/05/2025
 */
export default {
  Month: 1, // Tháng
  Quarter: 2, // Quý 
  Year: 3, // Năm
  Custom: 4 // Tùy chọn
};
